export const getReadabilityStatement = (
  number?: number
): { level: string; note: string } => {
  if (!number) return { level: '', note: '' }

  if (number >= 0 && number <= 10) {
    return {
      level: 'Professional',
      note: 'Content is very difficult to read'
    }
  } else if (number > 10 && number <= 30) {
    return {
      level: 'College graduate',
      note: 'Content is difficult to read'
    }
  } else if (number > 30 && number <= 50) {
    return {
      level: 'College',
      note: 'Content is a bit difficult to read'
    }
  } else if (number > 50 && number <= 54) {
    return {
      level: '12<sup>th</sup> grade',
      note: 'Content is fairly difficult to read'
    }
  } else if (number > 54 && number <= 57) {
    return {
      level: '11<sup>th</sup> grade',
      note: 'Content is fairly difficult to read'
    }
  } else if (number > 57 && number <= 60) {
    return {
      level: '10<sup>th</sup> grade',
      note: 'Content is fairly difficult to read'
    }
  } else if (number > 60 && number <= 65) {
    return {
      level: '9<sup>th</sup> grade',
      note: 'Content is easy to read'
    }
  } else if (number > 65 && number <= 70) {
    return {
      level: '8<sup>th</sup> grade',
      note: 'Content is easy to read'
    }
  } else if (number > 70 && number <= 80) {
    return {
      level: '7<sup>th</sup> grade',
      note: 'Content is very easy to read'
    }
  } else if (number > 80 && number <= 90) {
    return {
      level: '6<sup>th</sup> grade',
      note: 'Content is very easy to read'
    }
  } else {
    return {
      level: '5<sup>th</sup> grade',
      note: 'Content is very easy to read'
    }
  }
}
